import * as React from 'react';
import { ChiamaAPI, Trad } from '../components/';
import * as Dati from '../Dati';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import Select, { components } from 'react-select';

interface ITipoProps {
    Dati?: Dati.TDictTipo; //In TypeScript i dictionary possono avere solo string o number come tipo di chiave
    URL?: string; //Alternativa a Dati
    Campo: string; //Nome del campo da generare
    ID_Chiave?: number;
    ID_ChiaveString?: string;
    TradValori?: boolean;
    OnAggiorna: (e: string, valore?: any) => any;
    Disabilitato?: boolean;
    Richiesto?: boolean;
    LinkSelezione?: string;
    OnBlur?: (e: React.FormEvent<any> | string, valore?: any) => void;
    SceltaMultipla?: boolean;
    IgnoraPermessi?: boolean;
    Ordinato?: boolean;
    VersoOrdinamento?: string;
}

interface ITipoState {
    DatiDaAPI: Dati.CTipo[];
    Ricerca: string;
    Caricamento: boolean;
    ErroreCaricamento: boolean;
    Aggiornare: number;
}

export class Tipo extends React.Component<ITipoProps, ITipoState> {
    conditionSelector: any;
    public static defaultProps: Partial<ITipoProps> = {
        Dati: undefined,
        URL: undefined,
        ID_Chiave: undefined,
        ID_ChiaveString: undefined,
        TradValori: true,
        Disabilitato: false,
        Richiesto: false,
        SceltaMultipla: false,
        IgnoraPermessi: false,
    }

    private _Dati: Dati.CTipo[] = [];
    private _LinkSelezione: string = "";
    private _ID_ChiavePartenza: string = "";

    constructor(props: any) {
        super(props);

        this.state = {
            DatiDaAPI: this.props.Dati != undefined ? this.DictTipoToAny(this.props.Dati) : [],
            Ricerca: this.ID(props),
            Aggiornare: 1,
            Caricamento: false,
            ErroreCaricamento: false
        };
        this._Dati = this.props.Dati != undefined ? this.TraduciDati(props, this.DictTipoToAny(this.props.Dati), this.props.TradValori) : [];
        this._LinkSelezione = this.props.LinkSelezione != undefined ? this.props.LinkSelezione : "";
        this.OnSelectChange = this.OnSelectChange.bind(this);
        this.OnInputKeyDown = this.OnInputKeyDown.bind(this);
        this.OnLinkSelezione = this.OnLinkSelezione.bind(this);

        if (this.props.Campo == undefined) {
            console.warn("ATTENZIONE, la proprietà Campo per <Tipo /> non è impostata");
        }
    }

    private DatiRicercabili(url?: string): boolean {
        return Compat.ES6_String_endsWith(url || "", "=");
    }

    private DictTipoToAny(dati: Dati.TDictTipo): any[] {
        let Valori: any[] = [];
        for (let C in dati) {
            Valori.push({
                ID_Chiave: dati[C].ID_Chiave, Valore: dati[C].Valore, Permesso: dati[C].Permesso
            });
        }
        return Valori;
    }

    private SettaChiavePartenza(props: ITipoProps, dato: Dati.CTipo): void {
        if (this._ID_ChiavePartenza == "") {
            this._ID_ChiavePartenza = this.ID(props);
        }
    }

    private TraduciDati(props: ITipoProps, dati: Dati.CTipo[], traduci?: boolean): Dati.CTipo[] {
        let D: Dati.CTipo[] = [];
        for (let dato in dati) {
            this.SettaChiavePartenza(props, dati[dato]);
            let TrovaPermessoPartenza = -1
            if (dati[dato].Permesso != null) {
                if (dati[dato].Permesso != undefined) {
                    TrovaPermessoPartenza = (dati[dato].Permesso || []).indexOf(this._ID_ChiavePartenza);
                }
            }
            if (props.IgnoraPermessi                                                                   //Richiesto di ignorare i permessi
                || dati[dato].Permesso == undefined || dati[dato].Permesso == null                     //Permesso non è gestito
                || TrovaPermessoPartenza >= 0                                                          //Permesso è gestito e lo stato di arrivo è collegato allo stato di partenza selezionato
                || (TrovaPermessoPartenza == -1 && dati[dato].ID_Chiave == this._ID_ChiavePartenza)) { //Permesso è gestito, non attivato, ma la chiave e quella selezionata
                let ID = D.push(Compat.ES6_Object_assign(dati[dato])) - 1;
                if (traduci) {
                    if (D[ID].Parametri != null) {
                        D[ID].Valore = Trad.TradParam(D[ID].Valore, D[ID].Parametri);
                    } else {
                        D[ID].Valore = Trad.Trad(D[ID].Valore);
                    }
                }
            }
        }

        return D;
    }

    public shouldComponentUpdate(nextProps: ITipoProps, nextState: ITipoState): boolean {
        if (nextProps.URL != undefined) {
            if (this.DatiRicercabili(nextProps.URL)) {
                if (this.ID(nextProps) != "0" && this.ID(nextProps) != "") {
                    if (this.ID(nextProps) != nextState.Ricerca) {
                        if (!isNaN(Number(nextState.Ricerca.toString()))) {
                            this.setState({
                                Aggiornare: nextState.Aggiornare + 1,
                                Caricamento: true,
                                Ricerca: this.ID(nextProps)
                            });

                        }
                    }
                    else {
                        this._Dati = this.TraduciDati(nextProps, nextState.DatiDaAPI, nextProps.TradValori);
                    }
                }
            }
            else {
                this._Dati = this.TraduciDati(nextProps, nextState.DatiDaAPI, nextProps.TradValori);
            }
        }
        else if (nextProps.Dati != undefined) {
            this._Dati = this.TraduciDati(nextProps, this.DictTipoToAny(nextProps.Dati), nextProps.TradValori);
        }
        else {
            this._Dati = [];
        }
        return true;
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIListaTipo, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this._Dati = this.TraduciDati(this.props, dati.Dati, this.props.TradValori);
            this.setState({ DatiDaAPI: dati.Dati, Caricamento: false, ErroreCaricamento: false });
        }
        return false;
    }

    private OnErroreTipi(sender: ChiamaAPI, errore: Error): React.ReactNode {
        this.setState({ Caricamento: false, ErroreCaricamento: true });
        return false;
    }

    private OnSelectChange(newValue: any): void { //newValue è di tipo Dati.CTipo o Dati.CTipo[] (nel caso della SceltaMultipla)
        if (this.props.SceltaMultipla) {
            let ListaSelezione = (newValue as Dati.CTipo[]);
            if (ListaSelezione != null) {
                let ListaChiavi = new Array(ListaSelezione.length);
                for (let C in ListaSelezione) {
                    ListaChiavi[C] = ListaSelezione[C].ID_Chiave;
                }
                this.props.OnAggiorna(this.props.Campo, JSON.stringify(ListaChiavi));
            }
            else {
                this.props.OnAggiorna(this.props.Campo, "[]");
            }
        } else {
            const id = newValue == null ? "0" : (newValue as Dati.CTipo).ID_Chiave;
            this.props.OnAggiorna(this.props.Campo, id);
        }
    }

    private timeout: any;

    private OnSelectInputChange(inputValue: string): string {
        if (this.DatiRicercabili(this.props.URL)) {
            if (inputValue.length >= 2) {
                //EVITIAMO VENGA FATTA UNA CHIAMATA AL SERVER FINCHE' L'UTENTE NON HA FINITO DI DIGITARE
                if (this.timeout != undefined) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => { this.setState({ Caricamento: true, Aggiornare: this.state.Aggiornare + 1, Ricerca: inputValue }) }, 333);
            }
        }
        return inputValue;
    }

    private ID(props: ITipoProps): string {
        if (props.ID_Chiave == undefined) {
            if (props.SceltaMultipla) {
                let R = "";
                let ListaChiavi: string[] = JSON.parse(props.ID_ChiaveString || "");
                for (let C in ListaChiavi) {
                    R += ListaChiavi[C] + ",";
                }
                return R;
            } else {
                return props.ID_ChiaveString || "";
            }
        } else {
            return props.ID_Chiave.toString();
        }
    }

    private OnLinkSelezione(e: any) {
        e.persist();
        if (this._LinkSelezione != "" && e.target.className == " css-1uccc91-singleValue") {
            this.conditionSelector.select.onMenuClose();
            window.open(this._LinkSelezione + this.conditionSelector.select.state.selectValue[0].ID_Chiave, "_self");
        }
    }

    private OnInputKeyDown(e: React.KeyboardEvent<any>) {
        if (e.keyCode == 27) { //Se premo Esc, cerco nei risultati trovati quello attualmente selezionato. Se non lo trovo allora ricarico la lista
            let Trovato = false;
            for (let D = 0; D < this._Dati.length; D++) {
                if (this.ID(this.props) == this._Dati[D].ID_Chiave) {
                    Trovato = true;
                    break;
                }
            }
            if (!Trovato) {
                this.setState({ Aggiornare: this.state.Aggiornare + 1, Caricamento: true, Ricerca: this.ID(this.props) });
            }
        }
    }

    //private PopolaFrazionamento() {
    //    this._Frazionamento = {};
    //    this._Frazionamento["1"] = new Dati.CTipo("6", "Semestrale");
    //    this._Frazionamento["2"] = new Dati.CTipo("12", "Annuale");
    //}

    public OrdinaDati(): void {
        if (this.props.Ordinato != undefined && this.props.Ordinato) {
            if (this.props.VersoOrdinamento == undefined || this.props.VersoOrdinamento == "ASC") {
                this._Dati = this._Dati.sort((p1, p2) => ((p1.Valore > p2.Valore) ? 1 : -1));
            } else {
                this._Dati = this._Dati.sort((p1, p2) => ((p1.Valore < p2.Valore) ? 1 : -1));
            }
        }

    }

    GetValue() {
        if (this.props.SceltaMultipla) {
            const ids: string[] = [];
            this.ID(this.props).split(",").forEach((id: string) => {
                if (id && id !== "") {
                    ids.push(id);
                }
            });
            return this._Dati.filter(option => ids.indexOf(option.ID_Chiave) !== -1);
        } else {
            const firstOption = this._Dati[0];
            let value = this._Dati.filter(option => option.ID_Chiave == this.ID(this.props));

            if (value && !value.length && this.props.Richiesto && firstOption) {
                value = [firstOption];
                this.props.OnAggiorna(this.props.Campo, firstOption.ID_Chiave);
            }
            return value;
        }
    }

    public render() {
        this.OrdinaDati();

        if (this.props.URL == undefined) {
            if (this.props.Dati != undefined) {
                return <Select
                    required={this.props.Richiesto}
                    name={this.props.Campo}
                    isClearable={!this.props.Richiesto}
                    isDisabled={this.props.Disabilitato}
                    className="kt-input react-select"
                    value={this.GetValue()}
                    getOptionLabel={(option: Dati.CTipo) => option.Valore}
                    getOptionValue={(option: Dati.CTipo) => option.ID_Chiave}
                    placeholder={Trad.Trad("Seleziona...")}
                    noOptionsMessage={() => Trad.Trad("Nessun dato presente")}
                    isLoading={this.state.Caricamento}
                    options={this._Dati}
                    onChange={(nv: any) => this.OnSelectChange(nv)}
                    onBlur={this.props.OnBlur}
                    isMulti={this.props.SceltaMultipla}
                />;
            } else {
                return <Select
                    name={this.props.Campo}
                    isClearable={!this.props.Richiesto}
                    isDisabled={this.props.Disabilitato}
                    className="kt-input react-select"
                    placeholder={Trad.Trad("Dati non presenti")}
                    noOptionsMessage={() => Trad.Trad("Nessun dato presente")}
                    isLoading={false}
                    options={[]}
                    onBlur={this.props.OnBlur}
                    isMulti={this.props.SceltaMultipla}
                />
            }
        } else {
            return <React.Fragment>
                <span onMouseDown={this.OnLinkSelezione}>
                    <Select ref={(node) => this.conditionSelector = node} key={0}
                        onControlMouseDown
                        onKeyDown={(e: any) => this.OnInputKeyDown(e)}
                        name={this.props.Campo}
                        isClearable={!this.props.Richiesto}
                        isDisabled={this.props.Disabilitato}
                        className="kt-input react-select"
                        value={this.GetValue()}
                        getOptionLabel={(option: Dati.CTipo) => option.Valore}
                        getOptionValue={(option: Dati.CTipo) => option.ID_Chiave}
                        placeholder={Trad.Trad("Digita e seleziona...")}
                        noOptionsMessage={() => Trad.Trad(this.state.ErroreCaricamento ? "Errore caricamento dati" : "Nessun risultato trovato")}
                        options={this._Dati}
                        isLoading={this.state.Caricamento}
                        onChange={(nv: any) => this.OnSelectChange(nv)}
                        onInputChange={(iv) => this.OnSelectInputChange(iv)}
                        escapeClearsValue={false}
                        onBlur={this.props.OnBlur}
                        isMulti={this.props.SceltaMultipla}
                    />
                    {((this.state.Ricerca != "0" && this.state.Ricerca != "") || (!this.DatiRicercabili(this.props.URL))) &&
                        <ChiamaAPI key={1}
                            URL={this.props.URL + (this.DatiRicercabili(this.props.URL) ? encodeURIComponent(this.state.Ricerca) : "")}
                            Aggiornare={this.state.Aggiornare} OnRis={(s, d, dn) => this.OnRis(s, d, dn)}
                            OnErrore={(s, e) => this.OnErroreTipi(s, e)} />}

                </span>
            </React.Fragment>;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Tipi.tsx